module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveProduct($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Detalles del Producto")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "label": "Categorías",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.categories,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.categoryId),
      callback: function($$v) {
        _vm.model.categoryId = $$v
      },
      expression: "model.categoryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Agregar nueva categoría",
      "btn-function": ""
    },
    on: {
      "function-click": function($event) {
        _vm.form = true
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "input-form",
    attrs: {
      "type": "text",
      "placeholder": "Nombre del Producto"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "disabled": !!_vm.productId,
      "items": _vm.productTypes,
      "label": "Tipo",
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.model.type = $$v
      },
      expression: "model.type"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('file-upload-container', {
    attrs: {
      "label-for": ("image-" + (_vm.types.length + 1)),
      "image-url": _vm.model.urlImage,
      "min-resolution": 10,
      "max-resolution": 3000
    },
    on: {
      "upload": _vm.onUploadImage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Tipo de Unidad")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select mt-1",
    attrs: {
      "items": _vm.types,
      "label": "Seleccione el tipo",
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "types-tag mr-3",
          style: (("background-color: " + (data.item.color)))
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(data.item.code) + "\n\t\t\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(data.item.name) + "\n\t\t\t\t\t\t\t")]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-avatar', [_c('span', {
          staticClass: "types-tag",
          style: (("background-color: " + (data.item.color)))
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(data.item.code) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.model.unitId),
      callback: function($$v) {
        _vm.model.unitId = $$v
      },
      expression: "model.unitId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Peso")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.weigth),
      expression: "model.weigth",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-form mt-1",
    attrs: {
      "type": "number",
      "placeholder": "Contenido Neto"
    },
    domProps: {
      "value": (_vm.model.weigth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.weigth = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Precio Dólares")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.price),
      expression: "model.price",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-form",
    attrs: {
      "type": "number",
      "placeholder": "0.00",
      "step": "any"
    },
    domProps: {
      "value": (_vm.model.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.price = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Precio Soles")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.priceSoles),
      expression: "model.priceSoles",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-form",
    attrs: {
      "type": "number",
      "placeholder": "0.00",
      "step": "any"
    },
    domProps: {
      "value": (_vm.model.priceSoles)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.priceSoles = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Tipo de Impuestos")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "label": "Seleccione el tipo",
      "item-text": "description",
      "item-value": "id",
      "items": _vm.typeTaxes,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.igvId),
      callback: function($$v) {
        _vm.model.igvId = $$v
      },
      expression: "model.igvId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "mt-3": "",
      "pt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox",
    attrs: {
      "label": "Impuesto Requerido"
    },
    model: {
      value: (_vm.model.flagIgvRequired),
      callback: function($$v) {
        _vm.model.flagIgvRequired = $$v
      },
      expression: "model.flagIgvRequired"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "50%"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Agregar Categoría")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-1": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.categoryModel.name),
      callback: function($$v) {
        _vm.categoryModel.name = $$v
      },
      expression: "categoryModel.name"
    }
  }), _vm._v(" "), (_vm.$v.categoryModel.name && _vm.$v.categoryModel.name.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEl nombre es requerido\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Código")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.categoryModel.code),
      callback: function($$v) {
        _vm.categoryModel.code = $$v
      },
      expression: "categoryModel.code"
    }
  }), _vm._v(" "), (_vm.$v.categoryModel.code && _vm.$v.categoryModel.code.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEl código es requerido\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('v-switch', {
    staticClass: "input-switch",
    attrs: {
      "label": "Mostrar en POS",
      "hiden-details": ""
    },
    model: {
      value: (_vm.categoryModel.flagMain),
      callback: function($$v) {
        _vm.categoryModel.flagMain = $$v
      },
      expression: "categoryModel.flagMain"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pl-1": "",
      "mt-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Imagen")]), _vm._v(" "), _c('file-upload-container', {
    attrs: {
      "label-for": ("image-" + (_vm.categories.length + 1)),
      "image-url": _vm.categoryModel.urlImage,
      "min-resolution": 10,
      "max-resolution": 3000
    },
    on: {
      "upload": _vm.onUploadImageCategory
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action",
    attrs: {
      "type": "button",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "disabled": _vm.$v.$invalid
    },
    nativeOn: {
      "click": function($event) {
        _vm.createCategory($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95d66594","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/products/Create.vue
// module id = 1687
// module chunks = 6